<template>
	<div id="app">
		<!-- {{$t('message.hello')}} -->
		<router-view></router-view>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'App',
	components: {
	},

	computed:{
		/*...mapGetters('user', {
			user: 'getInfo'
		})*/
	},

	mounted() {
		console.log('process.env', process.env)
	}
}
</script>

<style lang="scss">
.vgt-global-search__input {
	display: none;
}
.vgt-global-search__actions {
	width: 100%;
	margin: 0 !important;
}
.admin{
	&.theme-1 {
		$primary-color: #4CAF50;
		$primary: #4CAF50;
		@import "./assets/vendor/vali-admin/src/sass/main";
		.app-sidebar__toggle{
			font-family: 'Font Awesome 5 Free';
		}
		.app-sidebar__user-avatar {
			height: 48px;
		}
		.modal {
			overflow: auto;
		}
	}

	.login-box {
		input[type=checkbox]{

			& + .label-text:before {
				font-family: 'Font Awesome 5 Free' !important;
			}

			&:checked + .label-text:before {
				content: "\f14a" !important;
			}

			& + .label-text:before {
				content: "\f0c8" !important;
			}
		}
	}
}

.client{
	&.theme-1 {
		$orange: #4CAF50;
		@import "./assets/vendor/startbootstrap-creative-master/src/scss/styles.scss";
	}
}

@import url(https://fonts.googleapis.com/css?family=Lato:300,400,400i,700);
@import url(https://fonts.googleapis.com/css?family=Niconne);
@import "bootstrap/scss/bootstrap";
@import "../../../node_modules/@fortawesome/fontawesome-free/css/all.css";
@import "../../../node_modules/magnific-popup/dist/magnific-popup.css";

.modal {
	overflow: auto !important;
}
</style>
